import { PricingRecordStatus } from "@services/QuoteBuilder/QuoteBuilderService";
import React from "react";

/**
 * Configuration for status banners
 */
type StatusConfig = {
  component: "confirmation" | "warning";
  getMessage: (customerName: string, date: string) => JSX.Element;
  dateField: "action_time" | "sign_submitted_time";
  testId: string;
  buttons?: { label: string; action: string }[];
};

export const STATUS_CONFIG: { [key: string]: StatusConfig } = {
  [PricingRecordStatus.QUOTE_SIGNED]: {
    component: "confirmation",
    getMessage: (customerName, date) => (
      <>
        This quote was <strong>signed</strong> by {customerName} on {date}
      </>
    ),
    dateField: "action_time",
    testId: "status-banner-signed",
  },
  [PricingRecordStatus.QUOTE_SENT]: {
    component: "confirmation",
    getMessage: (customerName, date) => (
      <>
        This quote was <strong>sent</strong> to {customerName} on {date}
      </>
    ),
    dateField: "sign_submitted_time",
    testId: "status-banner-sent",
    buttons: [
      {
        label: "Recall Quote",
        action: "recall-quote-action",
      },
    ],
  },
  [PricingRecordStatus.QUOTE_DECLINED]: {
    component: "warning",
    getMessage: (_customerName, date) => (
      <>
        The customer has <strong>declined</strong> the quote on {date}. <br /><br />
        Please contact the customer to proceed with an amended quote.
      </>
    ),
    dateField: "action_time",
    testId: "status-banner-declined",
    buttons: [
      {
        label: "Resend Quote",
        action: "resend-quote-action",
      },
      {
        label: "Create New Quote",
        action: "create-new-quote-action",
      },
    ],
  },
  [PricingRecordStatus.QUOTE_RECALLED]: {
    component: "warning",
    getMessage: (_customerName, date) => (
      <>
        This quote was <strong>recalled</strong> on {date}. <br /><br />
        Please resend or edit and resend the quote using the options below.
      </>
    ),
    dateField: "action_time",
    testId: "status-banner-recalled",
    buttons: [
      {
        label: "Resend Quote",
        action: "resend-quote-action",
      },
      {
        label: "Create New Quote",
        action: "create-new-quote-action",
      },
    ],
  },
  [PricingRecordStatus.QUOTE_EXPIRED]: {
    component: "warning",
    getMessage: (_customerName, date) => (
      <>
        This below quote <strong>expired</strong> on {date}. <br /> <br />
        Please resend or edit and resend the quote using the options below.
      </>
    ),
    dateField: "action_time",
    testId: "status-banner-expired",
    buttons: [
      {
        label: "Resend Quote",
        action: "resend-quote-action",
      },
      {
        label: "Create New Quote",
        action: "create-new-quote-action",
      },
    ],
  },
};
